import { Swiper, Navigation, Autoplay } from 'swiper'

Swiper.use([Navigation, Autoplay]);

if($('.reviews-slider').length) {

  $(window).on('load', function (e){
    var swiper = new Swiper(".reviews-slider", {
      slidesPerView: "auto",
      spaceBetween: 12,
      freeMode: true,
      loop: true,
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
      },
      navigation: {
        nextEl: ".reviews-slide-next",
        prevEl: ".reviews-slide-prev",
      }
    });
  })

}
